import React__default from 'react';
import { Link, Typography, FormControl, Select, MenuItem, FormHelperText, Box, TextareaAutosize, TextField } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KModalContentSection from '../../KModal/KModalContentSection/index.js';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import StyledAskDownloadStep, { classes } from './index.styled.js';

var AskDownloadStep = function (_a) {
    var _b, _c;
    var elementsToDownloadCount = _a.elementsToDownloadCount, askDownloadElementIds = _a.askDownloadElementIds, backFromAskDownload = _a.backFromAskDownload, _d = _a.KIcon, KIcon = _d === void 0 ? DefaultIcon : _d, fields = _a.fields, goToStepOne = _a.goToStepOne;
    var t = useTranslation("refront-components").t;
    var testIdDownloadSection = "testIdDownloadSection";
    var testIdCommentRequiredSpan = "testIdCommentRequiredSpan";
    var testIdCommentErrorMessage = "testIdCommentErrorMessage";
    var testIdCommentTextArea = "testIdCommentTextArea";
    var testIdEmail = "testIdEmail";
    var testIdLastName = "testIdLastName";
    var testIdFirstName = "testIdFirstName";
    var requiredErrorMessage = t("components.askDownloadStep.error.required");
    var emailFormatErrorMessage = t("components.askDownloadStep.error.emailFormat");
    var emailErrorMessage;
    if ((_b = fields.email) === null || _b === void 0 ? void 0 : _b.requiredError) {
        emailErrorMessage = requiredErrorMessage;
    }
    else if ((_c = fields.email) === null || _c === void 0 ? void 0 : _c.emailFormatError) {
        emailErrorMessage = emailFormatErrorMessage;
    }
    return (React__default.createElement(StyledAskDownloadStep, null,
        React__default.createElement(React__default.Fragment, null,
            goToStepOne && (React__default.createElement(Link, { className: classes.link, onClick: backFromAskDownload, underline: "hover" },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(KIcon, { className: "fa-regular fa-arrow-left fa-lg", sx: { paddingTop: 0.5 } }),
                    t("components.askDownloadStep.back.button.label")))),
            elementsToDownloadCount > 0 && (React__default.createElement(KModalContentSection, { testId: testIdDownloadSection, title: t("components.askDownloadStep.download.title", {
                    count: elementsToDownloadCount
                }) },
                React__default.createElement(Typography, { className: classes.subDescription, variant: "subtitle1" }, t("components.askDownloadStep.download.description"))))),
        React__default.createElement(KModalContentSection, { title: t("components.askDownloadStep.request.title", {
                count: askDownloadElementIds.length
            }) },
            React__default.createElement(Typography, { className: classes.subDescription, variant: "subtitle1" },
                React__default.createElement(SanitizeHtml, { html: t("components.askDownloadStep.request.description", {
                        count: askDownloadElementIds.length
                    }) }))),
        fields.use && (React__default.createElement(FormControl, { className: classes.formControl, required: fields.use.required, error: fields.use.requiredError },
            React__default.createElement(Typography, { className: clsx(classes.description, fields.use.requiredError && classes.error), variant: "subtitle1" },
                t("components.askDownloadStep.use.description"),
                fields.use.required && React__default.createElement("span", null, "\u00A0*")),
            React__default.createElement(Select, { value: fields.use.value, onChange: function (e) {
                    var _a;
                    if ((_a = fields.use) === null || _a === void 0 ? void 0 : _a.onChange) {
                        fields.use.onChange(e.target.value);
                    }
                } }, fields.use.options &&
                fields.use.options.map(function (use) {
                    return (React__default.createElement(MenuItem, { key: use, value: use }, use));
                })),
            fields.use.requiredError && React__default.createElement(FormHelperText, null, requiredErrorMessage))),
        React__default.createElement(Box, null,
            fields.comment && (React__default.createElement(FormControl, { className: classes.formControl, required: fields.comment.required, error: fields.comment.requiredError },
                React__default.createElement(Typography, { className: clsx(classes.description, fields.comment.requiredError && classes.error), variant: "subtitle1" },
                    t("components.askDownloadStep.reason.description"),
                    fields.comment.required && (React__default.createElement("span", { "data-testid": testIdCommentRequiredSpan }, "\u00A0*"))),
                React__default.createElement(TextareaAutosize, { className: clsx(classes.textarea, fields.comment.requiredError && classes.textareaError), "data-testid": testIdCommentTextArea, onChange: function (e) {
                        var _a;
                        if ((_a = fields.comment) === null || _a === void 0 ? void 0 : _a.onChange) {
                            fields.comment.onChange(e.target.value);
                        }
                    }, minRows: 4, maxRows: 6, value: fields.comment.value }),
                fields.comment.requiredError && (React__default.createElement(FormHelperText, { "data-testid": testIdCommentErrorMessage }, requiredErrorMessage)))),
            fields.email && (React__default.createElement(FormControl, { className: classes.formControl },
                React__default.createElement(TextField, { required: fields.email.required, label: t("components.askDownloadStep.email.label"), onChange: function (e) {
                        var _a;
                        if ((_a = fields.email) === null || _a === void 0 ? void 0 : _a.onChange) {
                            fields.email.onChange(e.target.value);
                        }
                    }, value: fields.email.value, error: !!emailErrorMessage, helperText: emailErrorMessage, "data-testid": testIdEmail }))),
            fields.lastName && (React__default.createElement(FormControl, { className: classes.formControl },
                React__default.createElement(TextField, { required: fields.lastName.required, label: t("components.askDownloadStep.lastName.label"), onChange: function (e) {
                        var _a, _b;
                        if ((_a = fields.lastName) === null || _a === void 0 ? void 0 : _a.onChange) {
                            (_b = fields.lastName) === null || _b === void 0 ? void 0 : _b.onChange(e.target.value);
                        }
                    }, value: fields.lastName.value, error: fields.lastName.requiredError, helperText: fields.lastName.requiredError && requiredErrorMessage, "data-testid": testIdLastName }))),
            fields.firstName && (React__default.createElement(FormControl, { className: classes.formControl },
                React__default.createElement(TextField, { required: fields.firstName.required, label: t("components.askDownloadStep.firstName.label"), onChange: function (e) {
                        var _a, _b;
                        if ((_a = fields.firstName) === null || _a === void 0 ? void 0 : _a.onChange) {
                            (_b = fields.firstName) === null || _b === void 0 ? void 0 : _b.onChange(e.target.value);
                        }
                    }, value: fields.firstName.value, error: fields.firstName.requiredError, helperText: fields.firstName.requiredError && requiredErrorMessage, "data-testid": testIdFirstName }))))));
};

export { AskDownloadStep as default };
//# sourceMappingURL=index.js.map
